"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = require("../styled-components");
const util_1 = require("../util");
const Text = styled_components_1.styled.span.attrs((props) => ({
    title: props.noTitle
        ? undefined
        : props.title !== undefined
            ? props.title
            : props.children !== undefined && typeof props.children === "string"
                ? (0, util_1.trimPunctuation)(props.children)
                : undefined,
    "data-testid": props.testId,
})) `
  text-overflow: ellipsis;
  overflow: hidden;
  ${({ wrapLines }) => (!wrapLines ? "white-space: nowrap;" : "")}
  font-size: 1rem;
  color: ${(props) => props.color || "currentcolor"};
  text-align: ${({ align }) => (align ? align : null)};
  flex: 0 ${({ shrink }) => (shrink ? "1" : "0")} auto;
`;
exports.default = Text;
//# sourceMappingURL=Text.js.map